<script lang="ts">
  import type {Collection} from '../types'
  import {t} from '../i18n'
  import api from '../api/api'
  import {modal} from '../stores/modal'
  import slugify from 'slugify'
  import ModalTemplate from '../shared/ModalTemplate.svelte'
  import ValidationMessage from '../shared/ValidationMessage.svelte'

  export let collection: Collection
  export let onSaved: (collection: Collection) => void

  let editedCollection = {...collection}
  let errors: Record<string, string[]> = {}
  let file: File | null = null

  async function submit(event: Event) {
    event.preventDefault()

    const formData = new FormData()
    formData.append('collection[image]', file || '')
    formData.append('collection[id]', editedCollection.id ? editedCollection.id.toString() : '')
    formData.append('collection[name]', editedCollection.name)
    formData.append('collection[description]', editedCollection.description || '')
    formData.append('collection[public]', (!editedCollection.private).toString())
    formData.append('collection[handle]', editedCollection.handle)

    try {
      errors = {}
      const response = editedCollection.id ?
        await api.put<Collection>(`/collections/${editedCollection.id}`, formData) :
        await api.post<Collection>('/collections', formData)

      onSaved(response)
      modal.close()
    } catch (response: any) {
      errors = response.errors || {}
    }
  }

  function uploadPicture(event: Event) {
    const input = event.target as HTMLInputElement
    if (input.files && input.files[0]) {
      file = input.files[0]
      const reader = new FileReader()
      reader.onload = (e) => {
        editedCollection.image_url = e.target?.result as string
      }
      reader.readAsDataURL(file)
    }
  }

  function setSlug() {
    editedCollection.handle = slugify(editedCollection.name, {remove: /[^a-zA-Z0-9_\-]/, lower: true}).slice(0, 100)
  }
</script>

<ModalTemplate size="small" scrolling>
  <div class="modal-content">
    <form class="create__collection__form" onsubmit={submit}>
      <h2>{editedCollection.id ? t.collections.edit.title : t.collections.create.title}</h2>

      <div class="line">
        <input required bind:value={editedCollection.name} placeholder={t.collections.create.name} oninput={setSlug}/>
        <ValidationMessage errors={errors.name}/>
      </div>

      <div class="line">
        <span>{t.collections.create.handle}</span>

        <input required bind:value={editedCollection.handle}
               placeholder={t.collections.create.handle}/>

        <ValidationMessage errors={errors.handle}/>
      </div>

      <div>
        <label for="image">
          {#if editedCollection.image_url}
            <div class="image content">
              <img class="dropzone-image" src={editedCollection.image_url} width="520"/>
            </div>
          {:else}
            <div class="dropzone">
              {t.collections.create.add_image}
            </div>
          {/if}
        </label>

        <input id="image" type="file" onchange={uploadPicture} style="display: none;"/>
      </div>

      <button class="ui button black" type="submit">
        {editedCollection.id ? t.collections.edit.title : t.collections.create.title}
      </button>

      <div class="checkbox-wrap make-private-wrap">
        <input id="private" type="checkbox" bind:checked={editedCollection.private}/>
        <label for="private">
          <span><i class="icon-p-check"></i></span>

          {t.collections.create.make_private}
        </label>
      </div>
    </form>
  </div>
</ModalTemplate>

<style>
  .create__collection__form .line {
    margin-bottom: 40px;
  }

  .create__collection__form input {
    font-size: 16px;
  }

  label[for=image] {
    cursor: pointer;
  }

  .image.content {
    height: 171px;
    margin-bottom: 30px;
  }
</style>